export const EMPLOYEES_SET = "employeesSet";
export const EMPLOYEE_SET = "employeeSet";
export const EMPLOYEES_RESET = "employeesReset";
export const EMPLOYEE_RESET = "employeeReset";
